import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-ahyush-login',
  templateUrl: './ahyush-login.component.html',
  styleUrls: ['./ahyush-login.component.css']
})
export class AhyushLoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  //redirectUrl =`${environment.baseUrl}/ahyush`;
  redirectUrl:string;
  private credential;

  constructor(
    //@Inject(DOCUMENT) private document: Document,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    
  ) { 
      this.credential=appConstants.commonAppConstants.otherCredential;
      this.redirectUrl=appConstants.commonAppConstants.routingUrl.ahyushUrl;//console.log(this.redirectUrl)
  }

  ngOnInit(){//console.log(this.credential);
      this.loginForm = this.formBuilder.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
      });
  }
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.error= "";
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
        return;
    }

    this.loading = true;
    this.login(this.f.username.value, this.f.password.value);
  }
  login(username,password ){
      if (this.credential.username === username && this.credential.password === password){
        //alert("sucess");
        //this.loginForm.reset();
        //this.ngOnInit();
        //this.router.navigateByUrl("http://localhost:4200/ahyush");
        //window.location.href='http://localhost:4200/ahyush';
        (window as any).open(this.redirectUrl, "_blank");
        }else{
          this.error = "Invalid credential."
        }
  }

}
